/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3MetricsTransactionRateRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsTransactionRateRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsTransactionRateRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  end: z.nullable(z.number()).default(null),
  start: z.nullable(z.number()).default(null),
  step: z.number().default(7200),
});

/** @internal */
export type GetApiV3MetricsTransactionRateRequest$Outbound = {
  end: number | null;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsTransactionRateRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsTransactionRateRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsTransactionRateRequest
> = z.object({
  end: z.nullable(z.number()).default(null),
  start: z.nullable(z.number()).default(null),
  step: z.number().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsTransactionRateRequest$ {
  /** @deprecated use `GetApiV3MetricsTransactionRateRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsTransactionRateRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsTransactionRateRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsTransactionRateRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsTransactionRateRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsTransactionRateRequest$Outbound;
}

export function getApiV3MetricsTransactionRateRequestToJSON(
  getApiV3MetricsTransactionRateRequest: GetApiV3MetricsTransactionRateRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsTransactionRateRequest$outboundSchema.parse(
      getApiV3MetricsTransactionRateRequest,
    ),
  );
}

export function getApiV3MetricsTransactionRateRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsTransactionRateRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsTransactionRateRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsTransactionRateRequest' from JSON`,
  );
}
